// The Dotacion grid's fixed-column widths -- shared between the table itself
// and its footer (TotalsRow), which has to line its own cells up with them.
export const NAME_W = 190
export const ROLE_W = 130
export const META_W = 60
export const CELL_W = 62
